var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShapeBl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 209,
    viewBox: "0 0 211 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-13.6328 152.006C10.9491 119.547 105.643 100.935 107.068 148.621C107.927 177.378 91.7595 201.786 64.8835 207.097C22.6997 215.432 31.0957 103.879 81.3284 66.9206C131.561 29.962 203.014 30.1504 209.806 0.48829",
    stroke: "#142C4B",
    strokeWidth: 2,
    strokeDasharray: "7 7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeBl);
export default __webpack_public_path__ + "static/media/shape-bl.4e96c0b059297ae07171daae3d156914.svg";
export { ForwardRef as ReactComponent };